export default {
  common: {
    yes: 'Да',
    no: 'Нет',
    from: 'от',
    list: 'Список',
    of: 'из',
    all: 'Все',
    active: 'Актив',
    inactive: 'Отключен',
    notFound: 'Не найдено',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    searchPlaceholder: 'Что ищем...',
    profile: 'Профиль',
    lpuWord: 'ЛПУ',
    main: 'Основной',
    available: 'Доступные',
    selected: 'Выбранные',
    promotional: 'Акционные',
    total: 'Итого',
    confirmTitle: 'Все не сохраненные данные будут потеряны',
    unsavedChangesMessage: 'Продолжить?',
    fillTitle: 'Поля будут автоматически очищены и заполнены данными из системы'
  },

  actions: {
    add: 'Добавить',
    apply: 'Применить',
    save: 'Сохранить',
    remove: 'Удалить',
    update: 'Изменить',
    edit: 'Редактировать',
    filter: 'Фильтр',
    close: 'Закрыть',
    clear: 'Очистить',
    choose: 'Выбрать',
    cancel: 'Отменить',
    login: 'Войти',
    logout: 'Выйти',
    detail: 'Подробно',
    object: 'Объект',
  },

  auth: {
    login: 'Логин',
    loginPlaceholder: 'Ваш логин',
    password: 'Пароль',
    passwordPlaceholder: 'Ваш пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль?',
    signIn: 'Войти',
    repeatPassword: 'Пароль повторно',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    repeatNewPassword: 'Повторите новый пароль',
    passwordChanged: 'Пароль изменен',
    fillAllFields: 'Заполните все поля.',
    passwordsDoNotMatch: 'Пароли не совпадают.',
    newPasswordSameAsOld: 'Новый пароль не должен совпадать со старым.',
    oldPasswordIncorrect: 'Старый пароль введён неверно',
  },

  notFound: {
    title: 'Мы не можем найти нужную вам страницу!',
    backToHome: 'Вернуться на главную страницу',
  },

  navigation: {
    main: 'Главная',
    news: 'Новости',
    dashboard: 'Аналитика',
    stock: 'Запасы',
    directories: 'Справочники',
    storeBalances: 'Остатки на складах',
    supplierContracts: 'Закупы',
    storeIn: 'Приемка товаров',
    storeWriteOff: 'Списание запасов',
    storeCheck: 'Инвентаризация',
    storeChange: 'Межфилиальные перемещения',
    marketing: 'Маркетинг',
    promotions: 'Акции',
    organizations: 'Организации',
    warehouses: 'Склады',
    cashes: 'Кассы',
    regions: 'Регионы',
    users: 'Пользователи',
    roles: 'Роли',
    metadata: 'Модули',
    inventory: 'Товары',
    profile: 'Профиль',
    notifications: 'Уведомление',
    allNotifications: 'Все уведомления',
    sales: 'Продажи',
    orders: 'Заказы',
    customers: 'Контрагенты',
    customerTypes: 'Типы контрагентов',
    customerGroups: 'Группы контрагентов',
    inventoryTypes: 'Типы товаров',
    inventoryGroups: 'Группы товаров',
    choisedItems: 'Выбранные товары',
    userType: 'Тип пользователя',
  },

  pages: {
    userProfile: 'Профиль пользователя',
    listWarehouse: 'Склады',
    addWarehouse: 'Добавить склад',
    listUser: 'Пользователи',
    listSupplierContract: 'Закупы',
    listStoreWriteOff: 'Списание запасов',
    addStoreWriteOff: 'Добавить списание запасов',
    listStoreIn: 'Приемка товаров',
    listStoreCheck: 'Инвентаризация',
    addStoreCheck: 'Добавить инвентаризацию',
    listStore: 'Запасы',
    listRole: 'Роли',
    listRegion: 'Регионы',
    addRegion: 'Добавить регион',
    listOrganization: 'Организации',
    addOrganization: 'Добавить организацию',
    listMetadata: 'Модули',
    listInventory: 'Товары',
    addInventory: 'Добавить товар',
    editInventory: 'Редактировать товар',
    listCash: 'Кассы',
    addCash: 'Добавить кассу',
    listStoreChange: 'Межфилиальные перемещения',
    addPromotion: 'Добавить акцию',
    addCustomer: 'Добавить контрагента',
    listCustomer: 'Список контрагентов',
    customerTypes: 'Типы контрагентов',
    groupContent: 'Содержимое группы',
    customerGroup: 'Группа контрагентов',
    inventoryGroup: 'Группа товаров',
    inventoryTypes: 'Типы товаров',
    addInventoryType: 'Добавить тип товара',
    addCustomerType: 'Добавить тип контрагента',
    addCustomerGroup: 'Добавить группу контрагентов',
    inventoryGroups: 'Группы товаров',
    customerGroups: 'Группы контрагентов',
    addInventoryGroup: 'Добавить группу товаров',
    listCustomerType: 'Типы контрагентов',
    addPriceType: 'Добавить тип цены',
    listPriceType: 'Типы цен',
    addTelegramBotUser: 'Добавить пользователя Telegram-бота',
    listTelegramBotUser: 'Пользователи Telegram-бота',
    addOrder: 'Добавить заказ',
    editOrder: 'Редактировать заказ',
    addInventories: 'Добавить товары',
    editCondition: 'Редактровать условие',
    addStoreChange: 'Добавить межфилиальные перемещения',
    addStoreInGoods: 'Добавить приемку товаров',
    addPurchases: 'Добавить закупы',
    purchases: 'Закупы',
    addDiscountMarkups: 'Добавить скидку/наценку',
    addReturn: 'Добавить возврат',
    order: 'Заказ',
    return: 'Возврат',
    returns: 'Возвраты',
  },

  forms: {
    filter: 'Фильтр',
    deletion: 'Удаление',
    deleteConfirm: 'Вы действительно хотите удалить этот объект?',
    status: 'Статус',
    name: 'Имя',
    title: 'Наименование',
    description: 'Описание',
    date: 'Дата',
    number: 'Номер',
    amount: 'Сумма',
    price: 'Цена',
    quantity: 'Количество',
    inn: 'ИНН',
    organization: 'Организация',
    warehouse: 'Склад',
    supplierContract: 'Договор с поставщиком',
    supplier: 'Поставщик',
    inventory: 'Товар',
    inventorySeries: 'Серия',
    storeBalance: 'Остаток на складе',
    validFrom: 'Действительно с',
    expirationDate: 'Дата окончания срока',
    deliveryDate: 'Дата поставки',
    deliveryDateShort: 'Дата доставки',
    packageQuantity: 'Количество в упаковке',
    language: 'Язык',
    languageChanged: 'Язык изменен',
    login: 'Логин',
    pinfl: 'ПИНФЛ',
    fact: 'Факт',
    balance: 'Остаток',
    position: 'Должность',
    start: 'Начало',
    end: 'Конец',
    cashPayment: 'Наличными',
    transferPayment: 'Переводом',
    optional: 'Опционально',
    minQuantity: 'Минимальное количество',
    maxQuantity: 'Максимальное количество',
    minRequired: 'Обязательный минимум',
    note: 'Примечание',
    storeRemaining: 'Остаток по складу',
    actualQuantity: 'Количество по факту',
    fromOrganization: 'Из организации',
    fromWarehouse: 'Из склада',
    toOrganization: 'В организацию',
    toWarehouse: 'В склад',
    inventoryType: 'Тип товара',
    lastName: 'Фамилия',
    middleName: 'Отчество',
    customerType: 'Тип покупателя',
    birth: 'День рождения',
    label: 'Название',
    alternativeName: 'Альтернативное название',
    fiz: 'Физическое лицо',
    yur: 'Юридическое лицо',
    createDetails: 'Создать детали',
    latitude: 'Высота',
    longitude: 'Долгота',
    series: 'Серия',
    passportNumber: 'Номер пасспорта',
    cardNumber: 'Номер пластиковой карты',
    transitAccount: 'Транзитный счет',
    settlementAccount: 'Расчётный счет',
    mfo: 'МФО',
    bank: 'Банк',
    editDetails: 'Изменить детали',
    promotionStart: 'Начало акции',
    promotionEnd: 'Конец акции',
    payment: 'Оплата',
    promotionType: 'Тип акции',
    addCondition: 'Добавить условие',
    bonuses: 'Бонусы',
    promotionWarehouses: 'Склады промоакции',
    selectDate: 'Выберите дату',
    phone: 'Телефон',
    mainContract: 'Основной договор',
    clientType: 'Тип клиента',
    contractNumber: 'Номер контракта',
    innPinfl: 'ИНН/ПИНФЛ',
    addDiscountsAndMarkups: 'Добавить скидки и наценки',
    type: 'Тип',
    discount: 'Скидка',
    markup: 'Наценка',
    calculationMethod: 'Способ расчёта',
    inPercent: 'В процентах',
    fixedAmount: 'Фиксированная сумма',
    value: 'Значение',
    promotions: 'промоакции',
    expiryPeriod: 'Срок годности',
    paymentType: 'Тип оплаты',
    discountMarkup: 'Скидка/наценка',
    totalAmount: 'Общая сумма',
    discountMarkupAmount: 'Сумма скидки/наценки',
    totalQuantity: 'Общее количество',
    orderAmount: 'Сумма заказа',
    discountPercent: 'Скидка (%)',
    userTypes: 'Типы пользователей',
    inventorySeriesFull: 'Серия инвентаря',
    phoneNumber: 'Номер телефона',
    discountMarkups: 'Скидки и наценки',
    cash: 'Наличные',
    transfer: 'Перечисление',
    customer: 'Контрагент',
    region: 'Регион',
    priceType: 'Тип цены',
    contract: 'Договор',
    product: 'товара',
    search: 'Поиск',
    createReturn: 'Создать возврат',
    addFullReturn: 'Добавить полный возврат',
    addPartialReturn: 'Добавить частичный возврат',
    dateNumberReturn: 'Номер и дата возврата',
    dateNumberOrder: 'Номер и дата заказа',
    discountAmount: 'Скидка в зависимости от суммы заказа',
    discountQuantity: 'Дополнение к количеству',
    orderStatusDraft: 'Черновик',
    orderStatusTest: 'Тест',
    returnTypeFull: 'Полный возврат',
    returnTypeCustom: 'Произвольный возврат',
    returnTypePartial: 'Частичный возврат',
    medicalRepresentative: 'Представитель',
    delivery: 'Доставщик'
  },

  tables: {
    name: 'Наименование',
    nameAndSeries: 'Наименование и серия',
    status: 'Статус',
    dateAndNumber: 'Дата и номер',
    organization: 'Организация',
    warehouse: 'Склад',
    supplierContract: 'Договор с поставщиком',
    login: 'Логин',
    pinfl: 'ПИНФЛ',
    storeIn: 'Приход',
    storeWriteOff: 'Списание',
    inventory: 'Товар',
    inventorySeries: 'Серия',
    quantity: 'Количество',
    balance: 'Остаток',
    fact: 'Факт',
    applied: 'Выполнение',
    posted: 'Оприходован',
    price: 'Цена',
    amount: 'Сумма',
    deliveryDate: 'Дата доставки',
    validFrom: 'Действительно с',
    expirationDate: 'Дата окончания срока',
    packageQuantity: 'Количество в упаковке',
    reserved: 'Бронь',
    idAndStatus: 'ID и статус',
    fromOrganizationAndWarehouse: 'Из организации и склада',
    toOrganizationAndWarehouse: 'В организацию и склад',
    builtIn: 'Встроенная',
  },

  entities: {
    cash: 'Касса',
    customer: 'Контрагент',
    detail: 'Деталь',
    inventory: 'Товар',
    inventoryItem: 'Товар',
    inventorySeries: 'Серия',
    metadata: 'Метадата',
    organization: 'Организация',
    payment: 'Оплата',
    region: 'Регион',
    role: 'Роль',
    store: 'Запас',
    storeCheck: 'Инвентаризация',
    storeIn: 'Приемка товаров',
    storePosting: 'Оприходование',
    storePostingProduct: 'Оприходование товара',
    storeWriteOff: 'Списание запасов',
    supplierContract: 'Договор с поставщиком',
    supplierContractShort: 'Контракт с поставщиком',
    user: 'Пользователь',
    warehouse: 'Склад',
    condition: 'Условие',
    bonus: 'Бонус',
    shortage: 'Недостаток',
    surplus: 'Лишнее',
    object: 'Объект',
    contract: 'Контракт',
    priceType: 'Тип цены',
    telegramBotUser: 'Пользователь телеграм',
    customerContractEdit: 'Редактировать договор',
    customerContractAdd: 'Создать договор',
    medicalRepresentative: 'Торговый представитель',
  },

  tabs: {
    inventory: 'Товар',
    details: 'Детали',
    series: 'Серия',
    storeIn: 'Приемка товаров',
    goods: 'Товары',
    contract: 'Договор',
    payments: 'Оплаты',
    permissions: 'Права',
    role: 'Роль',
    rolePermissions: 'Полномочия',
    shortage: 'Недостатки',
    surplus: 'Лишнее',
    inventoryGroup: 'Группы',
    customerDetails: 'Реквизиты',
    customerRegions: 'Регионы',
    customerGroups: 'Группы',
    returnNumber: 'Номер возврата',
    returnDate: 'Дата возврата',
    returnType: 'Тип возврата',
    orderNumber: 'Номер заказа',
    orderDate: 'Дата заказа',
    promoInventories: 'Акционные товары',
  },

  permissions: {
    read: 'Читать',
    create: 'Создавать',
    update: 'Обновлять',
    delete: 'Удалить',
    userModules: 'Модули пользователя',
    allModules: 'Все модули',
  },

  messages: {
    success: 'Удачно',
    successful: 'Успешно',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    delete: 'Удален(а)',
    created: '{message} Создан(а)',
    deleted: '{message} удален(а)',
    updated: '{message} Изменен(а)',
    added: '{message} Добавлен(а)',
  },

  operations: {
    posting: 'Оприходование',
    post: 'Оприходовать',
    cancelPosting: 'Отменить оприходование',
    postingConfirm: 'Вы действительно хотите оприходовать на склад?',
    cancelPostingConfirm: 'Вы действительно хотите отменить оприходование на склад?',
    inventoryCheck: 'Инвентаризация',
    applyInventoryCheck: 'Применить',
    cancelInventoryCheck: 'Отменить применение',
    inventoryCheckConfirm: 'Вы действительно хотите применить инвентаризацию?',
    cancelInventoryCheckConfirm: 'Вы действительно хотите отменить применение инвентаризации?',
    writeOff: 'Списание запасов',
    writeOffButton: 'Списать',
    cancelWriteOff: 'Отменить списание',
    writeOffConfirm: 'Вы действительно хотите списать со склада?',
    cancelWriteOffConfirm: 'Вы действительно хотите отменить списание со склада?',
    cancelWriteOffButton: 'Отменить списание',
    storeChangeConfirm: 'Вы действительно хотите применить?',
    cancelStoreChangeConfirm: 'Вы действительно хотите отменить применение?',
    writeOffTypoButton: 'Списать',
    postingLower: 'оприходовать',
  },

  dashboard: {
    salesAndReturnsDynamics: 'Динамика продаж и возвратов по временным отрезкам',
    customerGroupSales: 'Продажи по группам клиентов',
    ordersCountForPeriod: 'Кол-во заказов за период',
    ordersAmountForPeriod: 'Сумма заказов за период',
    returnsCountForPeriod: 'Кол-во возвратов за период',
    returnsAmountForPeriod: 'Сумма возвратов за период',
    selectedProductsShare: 'Доля от общей суммы по выбранным продуктам',
    name: 'Название',
    okb: 'ОКБ',
    akb: 'АКБ',
    akbShare: 'Доля АКБ',
    ordersCount: 'Кол-во заказов',
    ordersAmount: 'Сумма заказов',
    returnsCount: 'Кол-во возвратов',
    returnsAmount: 'Сумма возвратов',
    salesShare: 'Доля продаж',
    receipts: 'Поступления:',
    clientDebts: 'Задолженности клиентов:',
    index: 'Индекс',
    grossProfit: 'Валовая прибыль',
    thousand: 'тыс',
    billion: 'млрд',
  },

  promotion: {
    promotion: 'Акция',
    conditions: 'Условия',
    bonus: 'Бонус',
  },

  userRelations: {
    userUpdated: 'Пользователь изменен',
    userWarehouses: 'Склады пользователя',
    allWarehouses: 'Все склады',
    userRoles: 'Роли пользователя',
    allRoles: 'Все роли',
    userRegions: 'Регионы пользователя',
    allRegions: 'Все регионы',
    userOrganizations: 'Организации пользователя',
    allOrganizations: 'Все организации',
    userCashes: 'Кассы пользователя',
    allCashes: 'Все кассы',
  },

  profile: {
    settings: 'Настройки профиля',
    security: 'Безопасность',
    changePasswordHint: 'Для смены пароля нажмите кнопку изменить.',
    title: 'Добавить пользователя',
  },

  language: {
    ru: 'Русский язык',
    uz: 'Узбекский язык',
  },

  notifications: {
    title: 'Уведомление',
    all: 'Все уведомления',
    examples: {
      firstUser: 'Ботир Зокиров',
      firstAction: 'Клиент оплатил',
      firstProject: 'Дори - Эратон"',
      firstType: 'Мухлис фарм',
      secondUser: 'Жамшид Искандаров',
      secondAction: 'Дебиторская задолженность снова появилась',
      secondProject: 'Кретамин',
      secondType: 'Шаяна фарм',
      thirdUser: 'Ойпошша Жураева',
      thirdAction: 'Завтра сумаляк',
      thirdProject: 'HR тим билдинг',
      thirdType: 'Кадры',
    },
  },
}
